import React from 'react'

import { useMarket } from '@/utils/multi-markets/context'

import SearchHintsMainPage from '../home/HeroHome/SearchHintsMainPage'

import {
  BackgroundWrapper,
  Container,
  ContentWrapper,
  GridWrapper
} from './HomeHeroWrapperWithBackground.styled'

interface Props {
  content: React.ReactNode
  className?: string
  heroHome?: boolean
  anchor?: string
  dataTestId?: string
}

function HomeHeroWrapperWithBackground(props: Props) {
  const { content, className, heroHome = false, anchor, dataTestId } = props

  const { market } = useMarket()

  return (
    <Container
      className={className}
      heroHome={heroHome}
      {...(dataTestId && { 'data-test-id': dataTestId })}
    >
      <GridWrapper>
        <ContentWrapper>
          <BackgroundWrapper isPl={market === 'pl'}>
            {content}
          </BackgroundWrapper>
        </ContentWrapper>
      </GridWrapper>
      <SearchHintsMainPage />
    </Container>
  )
}

export default HomeHeroWrapperWithBackground
